/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Mk_Sol_Page_TitleInputs */

const en_mk_sol_page_title = /** @type {(inputs: Mk_Sol_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`KerjaBareng for ${i?.name}`)
};

const id_mk_sol_page_title = /** @type {(inputs: Mk_Sol_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`KerjaBareng untuk ${i?.name}`)
};

/**
* | output |
* | --- |
* | "KerjaBareng for {name}" |
*
* @param {Mk_Sol_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_page_title = /** @type {((inputs: Mk_Sol_Page_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Page_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_page_title(inputs)
	return en_mk_sol_page_title(inputs)
});